var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DateRangePickerInput',{staticClass:"filter-Period-form",attrs:{"enabled-period":_vm.enabledPeriod},model:{value:(_vm.dates),callback:function ($$v) {_vm.dates=$$v},expression:"dates"}})
}
var staticRenderFns = []

export { render, staticRenderFns }